"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var cached_promise_1 = __importDefault(require("../utils/decorators/cached-promise"));
var MerchantEntity_1 = __importDefault(require("./Entity/MerchantEntity"));
var MerchantApi = /** @class */ (function () {
    function MerchantApi(session) {
        this.merchantEntity = new MerchantEntity_1.default(session);
    }
    MerchantApi.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.merchantEntity.get()];
            });
        });
    };
    MerchantApi.prototype.getLocal = function () {
        return this.merchantEntity.getLocal();
    };
    MerchantApi.prototype.getAll = function () {
        return this.merchantEntity.getAll();
    };
    MerchantApi.prototype.update = function (merchant) {
        return this.merchantEntity.updateMerchantRequest(merchant);
    };
    MerchantApi.prototype.clean = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                options = (0, lodash_1.defaults)(options, { withDrivers: false });
                return [2 /*return*/, this.merchantEntity.clean(options)];
            });
        });
    };
    MerchantApi.prototype.createMerchantByAccountManager = function (newMerchant) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.merchantEntity.createMerchantByAccountManager(newMerchant)];
            });
        });
    };
    MerchantApi.prototype.proFeaturesEnabled = function () {
        var merchant = (0, lodash_1.get)(this.merchantEntity, 'service.session.merchant');
        if ((0, lodash_1.get)(merchant, 'custom_payments')) {
            return true;
        }
        if ((0, lodash_1.get)(merchant, 'pro')) {
            return false;
        }
        return true;
    };
    MerchantApi.prototype.featureFlags = function () {
        return (0, lodash_1.get)(this.merchantEntity, 'service.session.merchant.feature_flags');
    };
    MerchantApi.prototype.validateCopyMerchantSettings = function (copyData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.merchantEntity.validateMerchantSettingsForCopy(copyData.origin_merchant_id, copyData.destination_merchant_id)];
            });
        });
    };
    MerchantApi.prototype.copyMerchantSettings = function (copyData, fields) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.merchantEntity.copyMerchantSettings(copyData.origin_merchant_id, copyData.destination_merchant_id, fields)];
            });
        });
    };
    __decorate([
        cached_promise_1.default
    ], MerchantApi.prototype, "get", null);
    return MerchantApi;
}());
exports.default = MerchantApi;
//# sourceMappingURL=MerchantApi.js.map